/* 
  this.$tipsDialog(
    "提示",
    "确定删除吗？",
    "确定后将删除...",
    "el-icon-warning",
    "rgb(255, 178, 60)"
  ).then(() => {
    console.log('confirm')
  }).catch(() => {
    console.log('cancel')
  });
*/
import './tipsDialog.css'
const TipsDialog = {
  install: function (Vue) {
    Vue.prototype.$tipsDialog = function alert(
        title = "提示",
        msg = "是否删除",
        content = "是否删除当前项",
        iconType = "el-icon-warning", //图标类型
        iconColor = "#ccc", //图标颜色
        settings = {}
    ) { 
      Object.assign(settings, {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        dangerouslyUseHTMLString: true,
        customClass: 'el_tips_dialog'
      });
      return this.$confirm(`<div class="tips_dialog_content">
          <i class=${iconType} style="color:${iconColor}"></i>
          <p>
            <span>${msg}</span>
            <span>${content}</span>
          </p>
        </div> `, title, settings, msg, content, iconType, iconColor );
    };
  }
}

export default TipsDialog



// WEBPACK FOOTER //
// ./src/components/dialog/tipsDialog/index.js